import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d9otqoqqs38sj6jc7fpg';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');

    try {
      const formData = new FormData(e.currentTarget);
      const honeypot = formData.get('website_alt');
      if (honeypot && String(honeypot).trim() !== '') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注。');
        setEmail('');
        return;
      }

      const response = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(parsed?.meta?.message || '订阅失败，请稍后再试');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="py-12 md:py-16 bg-accent-500">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-background-50 mb-3">
          订阅更新通知
        </h2>
        <p className="text-sm text-background-50/80 mb-6 max-w-md mx-auto">
          第一时间获取最新韩国漫画更新通知，不错过任何精彩内容
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto" data-readdy-form>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="w-full sm:flex-1 px-4 py-3 bg-background-50 rounded-lg text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:ring-2 focus:ring-background-50/50"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-lg font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap disabled:opacity-50"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>
        {status === 'success' && (
          <p className="mt-3 text-sm text-background-50/90 animate-fadeIn">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-3 text-sm text-background-50/90 animate-fadeIn">{message}</p>
        )}
      </div>
    </section>
  );
}